module.exports = __webpack_public_path__ + "static/el_jefe_stage-95777fc5d3569fe6b870d72d4426f508.jpg";